<ng-container [formGroup]="parent">
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		formArrayName="array"
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em [class.warn-text]="showRequiredError"
					>No contacts added yet</em
				>
			</th>
		</ng-container>

		<ng-container matColumnDef="lastName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let contact">
				{{ contact.firstName }} {{ contact.lastName }}
			</td>
		</ng-container>

		<ng-container matColumnDef="phone">
			<th mat-header-cell *matHeaderCellDef>Phone Numbers</th>
			<td
				mat-cell
				*matCellDef="let contact; let i = index"
				[formGroupName]="findContactIndex(contact)"
			>
				<rpshared-phone-number-list
					formControlName="phoneNumbers"
				></rpshared-phone-number-list>
			</td>
		</ng-container>

		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef>Email Addresses</th>
			<td
				mat-cell
				*matCellDef="let contact; let i = index"
				[formGroupName]="findContactIndex(contact)"
			>
				<rpshared-email-address-list
					formControlName="emailAddresses"
				></rpshared-email-address-list>
			</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let contact; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="editContact(contact)"
					color="primary"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let contact; let i = index">
				<button
					type="button"
					mat-icon-button
					color="warn"
					rpsharedConfirm="Delete contact?"
					(onConfirmed)="array.removeAt(findContactIndex(contact))"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="dataSource.data?.length < 1"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="dataSource.data?.length > 0"
		></tr>
		<tr
			mat-row
			*matRowDef="let contact; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator
			class.hidden="true"
			pageSize="5"
			[pageSizeOptions]="[5, 10]"
		></mat-paginator>
		<button
			type="button"
			class="mr-4"
			(click)="addContact()"
			mat-mini-fab
			color="primary"
			matTooltip="Add Contact"
		>
			<mat-icon>add</mat-icon>
		</button>
	</div>
</ng-container>
